import type { MessageContainedProps} from './MessageContained';
import MessageContained from './MessageContained';

export type { MessageContainedProps };
export default MessageContained;